import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BuildingApplicationItemDto } from '@artemis-software/wr-api';
import { NbComponentStatus } from '@nebular/theme';
import { BuildingApplicationDetailDto } from '@artemis-software/wr-api';

interface StatusWithColor {
  color: NbComponentStatus,
  status: string
}

@Component({
  standalone: false,
  selector: 'wr-application-status-badge',
  templateUrl: './application-status-badge.component.html',
  styleUrl: './application-status-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ApplicationStatusBadgeComponent {
  readonly buildingApplicationItemDto = input.required<BuildingApplicationItemDto>();
  protected readonly ApplicationStatus = BuildingApplicationDetailDto.StatusEnum;

  readonly applicationStatus = computed<StatusWithColor>(() => {
    const currentStatus = this.buildingApplicationItemDto().status;

    switch (currentStatus) {
      case BuildingApplicationItemDto.StatusEnum.Pending:
        return { color: 'warning', status: 'In Bearbeitung' };
      case BuildingApplicationItemDto.StatusEnum.Accepted:
        return { color: 'success', status: 'Akzeptiert' };
      default:
        return { color: 'danger', status: 'Abgelehnt' };
    }
  });
}
